import { ArticleParagraph2 } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';

import * as React from 'react';

import { BannerWrapper } from '../../BannerWrapper';

import userFolder from './icons/userFolder.svg';

import * as styles from './styles.css';

export interface IBannerProps {
  onClick(): void;
  onClose(): void;
  rootClassName?: string;
}

export const Banner: React.FC<IBannerProps> = ({ onClick, onClose, rootClassName }) => {
  return (
    <BannerWrapper attributes={{ className: rootClassName, 'data-testid': 'Lead-Banner' }}>
      <button className={styles['close']} onClick={onClose}>
        <IconActionClose12 />
      </button>
      <div className={styles['content']}>
        <div className={styles['img']}>
          <img alt="" src={userFolder} />
        </div>
        <div>
          <ArticleParagraph2>
            Риелтор-партнёр Циан поможет купить
            <br />
            или продать любую недвижимость
          </ArticleParagraph2>
          <a className={styles['link']} href="/application-form/" onClick={onClick}>
            Подобрать риелтора
          </a>
        </div>
      </div>
    </BannerWrapper>
  );
};

Banner.displayName = 'Banner';
